document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".shaddow_btn_custom").forEach(button => {
        button.addEventListener("click", function () {
            // Remove border
            this.style.setProperty('box-shadow', '-1px 1px 0 black', 'important');
           this.style.setProperty('transform', 'translateY(1.5px)', 'important');

            // Reset border after 1 second
            setTimeout(() => {
                this.style.removeProperty('box-shadow');
                this.style.removeProperty('transform');
            }, 300); // 1000ms = 1 second
        });
    });
});


function updateAnnouncementBarHeight() {
  const announcementBar = document.querySelector('.announcement-bar-section');
  if (!announcementBar) return;

  // Get height (including padding & borders)
  const height = announcementBar.offsetHeight;

  // Set CSS variable on root element
  document.documentElement.style.setProperty('--height-of-announcement-bar', height + 'px');

  // Optional: if you want total header height (announcement + marquee) for padding or other use
  const marquee = document.querySelector('.section-scrolling-text');
  const marqueeHeight = marquee ? marquee.offsetHeight : 0;
  const totalHeight = height + marqueeHeight;

  // Example: Set total sticky header height as CSS var
  document.documentElement.style.setProperty('--total-sticky-header-height', totalHeight + 'px');

}

window.addEventListener('DOMContentLoaded', updateAnnouncementBarHeight);
window.addEventListener('resize', updateAnnouncementBarHeight);





// * Universalmegamenu+header above height calculating function for Collecrtion tab, Scroll tab sticky  *

window.updateCustomTabOffset = (function () {
  const root = document.documentElement;

  const selectors = {
    headerWrapper: '.header-wrapper',
    universalMegaMenu: '.universal-mega-menu-section',
    announcementBar: '.announcement-bar-section',
    marquee: '.section-scrolling-text',
  };

  const elements = {
    headerWrapper: document.querySelector(selectors.headerWrapper),
    universalMegaMenu: document.querySelector(selectors.universalMegaMenu),
    announcementBar: document.querySelector(selectors.announcementBar),
    marquee: document.querySelector(selectors.marquee),
  };

  function isVisible(el) {
    if (!el) return false;
    const style = getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && el.offsetHeight > 0;
  }

  // Core update function - recalculates and updates CSS var immediately
  function setOffset() {
  // Force reflow by reading offsetHeight before measuring anything else
  if (elements.headerWrapper) elements.headerWrapper.offsetHeight;
  if (elements.universalMegaMenu) elements.universalMegaMenu.offsetHeight;
  if (elements.announcementBar) elements.announcementBar.offsetHeight;
  if (elements.marquee) elements.marquee.offsetHeight;

  const stickyHeight = elements.headerWrapper && isVisible(elements.headerWrapper) ? elements.headerWrapper.offsetHeight : 0;
  const megaMenuHeight = elements.universalMegaMenu && isVisible(elements.universalMegaMenu) ? elements.universalMegaMenu.offsetHeight : 0;
  const announcementHeight = elements.announcementBar && isVisible(elements.announcementBar) ? elements.announcementBar.offsetHeight : 0;
  const marqueeHeight = elements.marquee && isVisible(elements.marquee) ? elements.marquee.offsetHeight : 0;

  const totalHeight = stickyHeight + megaMenuHeight + announcementHeight + marqueeHeight - 1;

  root.style.setProperty('--cstm-tab-header-height', `${totalHeight}px`);
}


  // Setup ResizeObserver to auto-update on element resize
  const resizeObserver = new ResizeObserver(() => {
    setOffset();
  });

  Object.values(elements).forEach(el => {
    if (el) resizeObserver.observe(el);
  });

  // Run on DOM ready and window resize
  document.addEventListener('DOMContentLoaded', setOffset);
  window.addEventListener('resize', setOffset);

  return setOffset; // Expose core function directly for instant calls
})();

